import { createSlice } from "@reduxjs/toolkit";
import { DocumentVendorProductsAction, documentVendorProductsEditAction, vendorProductsAction } from "../asyncActions/vendorActions";
import dayjs from "dayjs";
import { getManufactureProductListAction } from "../asyncActions/productAction";
import { wasteProductsAction } from "../asyncActions/warhouseActions";
import { wasteDocumentProductAction } from "../asyncActions/documentActions";

function transformData(data) {
    let vendors = [];
    let vendorProducts = [];

    for (let elem of data) {
        // Обрабатываем каждого поставщика для товара
        for (let vendor of elem.vendors) {
            if (!vendors.some(el => el.id === vendor.id)) {
                vendors.push(vendor);  // Добавляем поставщика в список, если его еще нет
            }
        }

        // Преобразуем список поставщиков в массив их идентификаторов
        elem.vendors = elem.vendors.map(vendor => vendor.id);
        vendorProducts.push(elem);
    }

    return {
        vendors,
        vendorProducts
    };
}


const vendorSlice = createSlice({
    name: 'vendorSlice',
    initialState: {
        selectFilter: {
            vendor: "",
            product: ''
        },
        dateFilter: {
            date: dayjs()
        },
        branchFilter: {
            branchId: 0,
            branchType: 0,
        },
        vendorList: [],
        productList: [],
        productVendorList: [],
        productWasteList: [],
        productDocumentVendotList: [],
        dataLoad: false,
    },
    reducers: {
        clearFilterVendor(state) {
            state.selectFilter = {
                vendor: '',
                product: ''
            }
        },
        setSelectFilter(state, action) {
            const { filter, value } = action.payload
            state.selectFilter[filter] = value
        },
        setBranchFilter(state, action) {
            const { field, value } = action.payload
            if (field === 'branchId' || field === 'branchType') {
                state.branchFilter[field] = value
            }
        },
        setDate(state, action) {
            state.dateFilter.date = action.payload
        },
        setProductVendor(state, action) {
            state.productVendorList = state.productList.filter(product => product.vendors.includes(action.payload))
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(vendorProductsAction.fulfilled, (state, action) => {
                const { vendors, vendorProducts } = transformData(action.payload)
                state.vendorList = vendors
                state.productList = vendorProducts
                // state.productList = action.payload
                state.dataLoad = false
            })
            .addCase(vendorProductsAction.rejected, (state, action) => {
                state.dataLoad = false
            })
            .addCase(vendorProductsAction.pending, (state, action) => {
                state.dataLoad = true
            })

            .addCase(DocumentVendorProductsAction.rejected, (state, action) => {
                state.dataLoad = false
            })
            .addCase(DocumentVendorProductsAction.pending, (state, action) => {
                state.dataLoad = true
            })
            .addCase(DocumentVendorProductsAction.fulfilled, (state, action) => {
                state.dataLoad = false
                state.productDocumentVendotList = action.payload
            })

            .addCase(wasteDocumentProductAction.rejected, (state, action) => {
                state.dataLoad = false
            })
            .addCase(wasteDocumentProductAction.pending, (state, action) => {
                state.dataLoad = true
            })
            .addCase(wasteDocumentProductAction.fulfilled, (state, action) => {
                state.dataLoad = false
                state.productWasteList = action.payload
            })


            .addCase(documentVendorProductsEditAction.rejected, (state, action) => {
                state.dataLoad = false
            })
            .addCase(documentVendorProductsEditAction.pending, (state, action) => {
                state.dataLoad = true
            })
            .addCase(documentVendorProductsEditAction.fulfilled, (state, action) => {
                state.dataLoad = false
            })



            .addCase(getManufactureProductListAction.fulfilled, (state, action) => {
                state.productList = action.payload
                state.dataLoad = false
            })
            .addCase(getManufactureProductListAction.rejected, (state, action) => {
                state.dataLoad = false
            })
            .addCase(getManufactureProductListAction.pending, (state, action) => {
                state.dataLoad = true
            })

            
            .addCase(wasteProductsAction.fulfilled, (state, action) => {
                state.productList = action.payload
                state.dataLoad = false
            })
            .addCase(wasteProductsAction.rejected, (state, action) => {
                state.dataLoad = false
            })
            .addCase(wasteProductsAction.pending, (state, action) => {
                state.dataLoad = true
            })

    }
})


export default vendorSlice.reducer

export const getBufferData = (state) => state.vendor

export const {
    clearFilterVendor,
    setSelectFilter,
    setBranchFilter,
    setProductVendor,
    setDate
} = vendorSlice.actions
